var CloneConversationLogicErrorType;
(function (CloneConversationLogicErrorType) {
    CloneConversationLogicErrorType["ERROR_FULL"] = "ERR-CLONE-FULL";
    CloneConversationLogicErrorType["ERROR_PARTIAL"] = "ERR-CLONE-PARTIAL";
    CloneConversationLogicErrorType["ERROR_GENERIC"] = "ERR-CLONE-GENERIC";
    CloneConversationLogicErrorType["ERROR_EMPTY_TITLE"] = "ERR-CLONE-EMPTY_TITLE";
})(CloneConversationLogicErrorType || (CloneConversationLogicErrorType = {}));
var CloneConversationType;
(function (CloneConversationType) {
    CloneConversationType["FULL"] = "full";
    CloneConversationType["PARTIAL"] = "partial";
    CloneConversationType["CANCEL"] = "cancel";
    CloneConversationType["UNKNOWN"] = "unknown";
})(CloneConversationType || (CloneConversationType = {}));
export { CloneConversationLogicErrorType, CloneConversationType };
